export const localStorageKeys = {
  colorMode: "colorMode",
  iso639_1: "iso639_1",
  jwtToken: "jwtToken",
  receiveNewReservationEmails: "receiveNewReservationEmails",
  receiveUpdatedReservationEmails: "receiveUpdatedReservationEmails",
  receiveCancelledReservationEmails: "receiveCancelledReservationEmails",
  firstDayOfWeek: "firstDayOfWeek",
} as const;

export type LocalStorageKey = keyof typeof localStorageKeys;

export function getLocalStorage(
  key: LocalStorageKey,
  options: { booleanCast: true },
): boolean | null;
export function getLocalStorage(key: LocalStorageKey): string | null;
export function getLocalStorage(
  key: LocalStorageKey,
  options?: { booleanCast: true },
) {
  const value = localStorage.getItem(key);

  if (!options?.booleanCast) return value;

  return value === null ? null : value === "true";
}

export const setLocalStorage = (key: LocalStorageKey, value: string) =>
  localStorage.setItem(key, value);

export const removeLocalStorage = (key: LocalStorageKey) =>
  localStorage.removeItem(key);
